import { gql } from "lib/apolloClient";

export const getSchoolisationInstructionsQuery = gql`
  query getSchoolisationInstructions($module: String) {
    ai {
      schoolisationInstructions(module: $module)
    }
  }
`;
